"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import GradientButton from "@/components/ui/GradientButton";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Image from "next/image";
export default function ShopifyDeveloperHero() {
  const $ = _c(45);
  const desktopAnimations = useDesktopAnimations();
  const reduceMotion = useReducedMotion();
  const t0 = reduceMotion ? 0 : 20;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      opacity: 0,
      y: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== reduceMotion) {
    t2 = delay => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: reduceMotion ? 0 : 0.6,
        delay,
        ease: "easeOut" as const
      }
    });
    $[2] = reduceMotion;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      hidden: t1,
      visible: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const reveal = t3;
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="pointer-events-none absolute inset-0 -z-20 opacity-40 bg-[radial-gradient(circle,rgba(75,88,125,.18)_0.8px,transparent_0.9px)] bg-[length:7px_7px] [mask-image:linear-gradient(to_bottom,#000_0%,rgba(0,0,0,.7)_82%,transparent_100%)] dark:opacity-15" aria-hidden="true" />;
    t5 = <div className="pointer-events-none absolute left-1/2 -bottom-[35%] -translate-x-1/2 -z-10 h-[75%] w-[85%] max-w-[1000px] rounded-full bg-[rgba(91,244,220,.2)] blur-[80px] dark:bg-[rgba(91,244,220,.06)]" aria-hidden="true" />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const t6 = desktopAnimations ? "hidden" : false;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <br className="hidden sm:inline" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== reveal || $[11] !== t6) {
    t8 = <motion.h1 id="shopify-hero-title" className="w-full text-3xl min-[400px]:text-4xl sm:text-5xl lg:text-[48px] xl:text-[56px] font-bold leading-[1.15] tracking-tight text-[#050748] dark:text-white" variants={reveal} initial={t6} animate="visible" custom={0.1}>Hire Dedicated {t7}Shopify Developer</motion.h1>;
    $[10] = reveal;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = desktopAnimations ? "hidden" : false;
  let t10;
  if ($[13] !== reveal || $[14] !== t9) {
    t10 = <motion.p className="mt-4 sm:mt-5 max-w-[580px] mx-auto lg:mx-0 text-sm min-[400px]:text-[15px] sm:text-base lg:text-lg leading-relaxed text-[#66698a] dark:text-gray-300" variants={reveal} initial={t9} animate="visible" custom={0.2}>Hire remote Shopify developers for sales-driven eCommerce websites with advanced technologies, ensuring expertise and budget-friendly online store development.</motion.p>;
    $[13] = reveal;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = desktopAnimations ? "hidden" : false;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <GradientButton variant="pink-purple" className="!min-h-[48px] sm:!min-h-[52px] !h-auto !py-3.5 !px-7 sm:!px-9 !text-sm sm:!text-base !font-semibold !shadow-md group" href="/contact"><span>Contact Us</span><ArrowRight className="transition-transform duration-200 group-hover:translate-x-1 shrink-0" aria-hidden="true" size={18} strokeWidth={2.2} /></GradientButton>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== reveal || $[18] !== t11) {
    t13 = <motion.div className="mt-6 sm:mt-8 flex justify-center lg:justify-start w-full sm:w-auto" variants={reveal} initial={t11} animate="visible" custom={0.3}>{t12}</motion.div>;
    $[17] = reveal;
    $[18] = t11;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t10 || $[21] !== t13 || $[22] !== t8) {
    t14 = <div className="z-10 w-full max-w-[640px] text-center lg:text-left lg:w-[52%] xl:w-[50%] flex flex-col items-center lg:items-start">{t8}{t10}{t13}</div>;
    $[20] = t10;
    $[21] = t13;
    $[22] = t8;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== desktopAnimations || $[25] !== reduceMotion) {
    t15 = desktopAnimations ? {
      opacity: 0,
      x: reduceMotion ? 0 : 40,
      scale: reduceMotion ? 1 : 0.98
    } : false;
    $[24] = desktopAnimations;
    $[25] = reduceMotion;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      opacity: 1,
      x: 0,
      scale: 1
    };
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  const t17 = reduceMotion ? 0 : 0.7;
  let t18;
  if ($[28] !== t17) {
    t18 = {
      duration: t17,
      delay: 0.25,
      ease: "easeOut"
    };
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== desktopAnimations) {
    t19 = desktopAnimations ? {
      y: [0, -8, 0]
    } : undefined;
    $[30] = desktopAnimations;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== desktopAnimations) {
    t20 = desktopAnimations ? {
      duration: 5,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[32] = desktopAnimations;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Image src="/images/shopify/hero-img -1.png" alt="Shopify developer building a secure online store" width={700} height={535} priority={true} sizes="(max-width: 480px) 340px, (max-width: 768px) 460px, (max-width: 1024px) 500px, (max-width: 1280px) 560px, 620px" className="h-auto w-full object-contain drop-shadow-sm select-none pointer-events-none" />;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t19 || $[36] !== t20) {
    t22 = <motion.div className="relative h-auto w-full max-w-[280px] min-[380px]:max-w-[320px] min-[480px]:max-w-[380px] sm:max-w-[460px] md:max-w-[500px] lg:max-w-[560px] xl:max-w-[620px]" animate={t19} transition={t20}>{t21}</motion.div>;
    $[35] = t19;
    $[36] = t20;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t15 || $[39] !== t18 || $[40] !== t22) {
    t23 = <motion.div className="flex w-full justify-center lg:justify-end lg:w-[48%] xl:w-[50%] mt-8 lg:mt-0" initial={t15} animate={t16} transition={t18}>{t22}</motion.div>;
    $[38] = t15;
    $[39] = t18;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t14 || $[43] !== t23) {
    t24 = <section id="shopify-hero-section" className="relative isolate overflow-hidden bg-[linear-gradient(180deg,#ffffff_0%,#f8ffff_52%,#d9fffa_100%)] text-[#050748] dark:bg-gray-950 dark:bg-none dark:text-white pt-24 sm:pt-28 md:pt-32 lg:pt-36 pb-12 sm:pb-16 lg:pb-20 transition-colors duration-300" aria-labelledby="shopify-hero-title">{t4}{t5}<div className="relative mx-auto flex flex-col lg:flex-row items-center justify-between gap-10 sm:gap-12 lg:gap-8 xl:gap-12 w-full max-w-[1280px] px-4 min-[400px]:px-6 sm:px-8 lg:px-10">{t14}{t23}</div></section>;
    $[42] = t14;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  return t24;
}